// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"2cf00f16","21":"e8a04d0d","453":"2ba38637","614":"17991dcc","654":"f78c0dc4","735":"a56b01c4"}[chunkId] + ".chunk.js";
};